import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue' 

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/certificate/:id',
        name: 'Certificate',
        component: () => import('../views/Certificate.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/courses',
        name: 'CoursesIndex',
        component: () => import('../views/Courses/Index.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/courses/:id',
        name: 'CourseInfo',
        component: () => import('../views/Courses/Info.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/courses/details/:id',
        name: 'CourseDetails',
        component: () => import('../views/Courses/Details.vue'),
        meta:{
            requiresAuth: true,
        },
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta:{
            requiresAuth: true,
        },
    },
    //Cart
    {
        path: '/cart',
        name: 'Cart',
        component: () => import('../views/Cart/Cart.vue'),
        meta:{
            requiresAuth: true,
        },
    },
    {
        path: '/cartresult',
        name: 'CartResult',
        component: () => import('../views/Cart/Result.vue'),
        meta:{
            requiresAuth: true,
        },
    },
    //Auth
    {
        path: '/auth/login',
        name: 'Login',
        component: () => import('../views/Auth/Login.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/auth/callback',
        name: 'AuthCallback',
        component: () => import('../views/Auth/AuthCallback.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/auth/register',
        name: 'Register',
        component: () => import('../views/Auth/Register.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/auth/forgot',
        name: 'Forgot',
        component: () => import('../views/Auth/Forgot.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/auth/forgotSuccess',
        name: 'ForgotSuccess',
        component: () => import('../views/Auth/ForgotSuccess.vue'),
        meta:{
            requiresAuth: false,
        },
    },
    {
        path: '/auth/reset/:id',
        name: 'Reset',
        component: () => import('../views/Auth/Reset.vue'),
        meta:{
            requiresAuth: false,
        },
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

router.beforeEach(async (to, from, next) => {
    var user = localStorage.getItem("userState");
    if(to.meta.requiresAuth){
        //need to check if user is authorized
        if (!user) {
            // redirect the user to the login page
            next({ name: 'Login' });
        }
        else{
            next();
        }
    }
    else{
        next();
    }


})

export default router